import { render, staticRenderFns } from "./Colxx.vue?vue&type=template&id=6970696c&"
import script from "./Colxx.vue?vue&type=script&lang=js&"
export * from "./Colxx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6970696c')) {
      api.createRecord('6970696c', component.options)
    } else {
      api.reload('6970696c', component.options)
    }
    module.hot.accept("./Colxx.vue?vue&type=template&id=6970696c&", function () {
      api.rerender('6970696c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/Colxx.vue"
export default component.exports